import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import generateUniqueId from '@insight/toolkit-utils/lib/generators/generateUniqueId';

import Icon from '../Icon/Icon';
import ScreenReaderOnly from '../Accessibility/ScreenReaderOnly/ScreenReaderOnly';

const fillTypeMap = {
  full: 'star',
  half: 'star-half',
  outline: 'star-outline',
};

const Star = ({ editable, fillType, index, onClick, ...rest }) => {
  if (editable) {
    const id = generateUniqueId();
    return (
      <>
        <input
          className="c-star-rating__input u-hide-visually"
          id={id}
          name="starRating"
          onClick={onClick}
          type="radio"
          value={`${index}`}
        />
        <label className="c-star-rating__label" htmlFor={id}>
          <ScreenReaderOnly>
            <span className="u-hide-visually">{index} star</span>
          </ScreenReaderOnly>
          <Icon className="c-star-rating__icon" icon="star" />
        </label>
      </>
    );
  }

  const iconType = fillTypeMap[fillType];
  return <Icon className="c-star-rating__icon" icon={iconType} />
};

export default Star;

Star.propTypes = {
  editable: PropTypes.bool,
  fillType: PropTypes.oneOf(['full', 'half', 'outline']),
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func,
};

Star.defaultProps = {
  editable: false,
  fillType: 'outline',
};
